/* eslint-disable max-len */
import React from 'react';
function ElmoAdmin() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3ZM5 19H19V5H5V19ZM8 17V7C10.3077 7 13.1832 7 15.5 7.00477V8.77004H10.3755V10.917H15.3013V12.7586H10.3665V15.2013H15.5903V17H8Z", fill: "#212121" })));
}
export default ElmoAdmin;
